<template>
  <div class="list-group list-group-bordered" ref="list">
    <div class="list-group-header d-flex align-items-center"
         :class="{ 'justify-content-between': extraSmall || small, 'flex-column': extraSmall || small }"
         v-if="showHeader">
        <span :class="{ 'mb-2': extraSmall || small }">{{ researchers.length }} {{
            researchers.length === 1 ? 'Coinvestigador externo agregado' : 'Coinvestigadores externos agregados'
          }}</span>
    </div>
    
    <template v-if="researchers && researchers.length">
      <div class="list-group-item"
          :data-id="researcher.id"
          v-for="(researcher, index) in researchers"
          :key="researcher.id"
          :class="{ 'd-none': researchers.length > 3 && index >= 3 && !showAll}">
        
        <div class="list-group-item-figure align-items-start">
          <a href="#" class="user-avatar">
            <img :src="researcher.avatar"
                :alt="researcher.full_name">
          </a>
        </div>
        
        <div class="list-group-item-body">
          <h4 class="list-group-item-title">
            <a href="#">
              <template v-if="researcher.invited_by_email">
                 {{ researcher.email }} <small class="text-muted">(invitación vía correo electrónico)</small>
              </template>
              <template v-else>
                {{ researcher.full_name }}
              </template>
            </a>
          </h4>
          <p class="list-group-item-text small mb-1"
            v-if="researcher.user_info && researcher.user_info.expertise_area">
            {{ researcher.user_info.expertise_area }}
          </p>
          <p class="list-group-item-text small mt-1" v-if="showStatus">
            <span class="badge"
                  :class="getStatusClasses(researcher)">{{ getStatusTitle(researcher) }}</span></p>
        </div>
        
        <div class="list-group-item-figure align-items-start" v-if="showActions && !readonly">
          <div class="dropdown">
            <button class="btn btn-sm btn-icon btn-light"
                    data-toggle="dropdown"><i
              class="fa fa-fw fa-ellipsis-v"></i></button>
            <div class="dropdown-menu dropdown-menu-right">
              <div class="dropdown-arrow mr-n1"></div>
              <button type="button"
                      class="dropdown-item"
                      @click="resendInvitation(researcher)"
                      :disabled="canResendInvitation(researcher)"
                      ref="btn-resend-invitation">Reenviar invitación
              </button>
              
              <button type="button"
                      class="dropdown-item"
                      @click="inviteAgain(researcher)"
                      v-if="canInviteAgain(researcher)"
                      ref="btn-resend-invitation">Volver a invitar
              </button>

              <div class="dropdown-divider"></div>
            
              <button type="button"
                      class="dropdown-item"
                      @click="cancelInvitation(researcher)"
                      :disabled="canCancelInvitation(researcher)"
                      ref="btn-remove-researcher">Cancelar invitación
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    
    <button class="btn btn-block btn-subtle-dark mt-3 keep-enabled" v-if="researchers.length > 3"
            @click.prevent="showAll = !showAll">Mostrar {{ showAll ? 'menos' : 'todos los' }} coinvestigadores
    </button>

    <portal to="external-researchers-modals">
      <ok-cancel-dialog id="delete-external-researcher-modal"
                        title="Eliminar coinvestigador externo de protocolo"
                        content="<p>¿Está seguro de eliminar el coinvestigador del protocolo?</p>"
                        ok-button-text="Eliminar"
                        ok-button-type="danger"
                        :ok-callback="deleteResearcher"
                        ref="delete-external-researcher-modal"></ok-cancel-dialog>
    </portal>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  import OkCancelDialog from '../ui/OkCancelDialog'
  
  export default {
    name: 'ExternalResearchersList',
    components: {
      OkCancelDialog,
    },
    props: {
      researchers: {
        type: Array,
        default: () => ([]),
      },
      protocol: {
        type: Object,
        default: null,
      },
      showHeader: {
        type: Boolean,
        default: true,
      },
      showActions: {
        type: Boolean,
        default: true,
      },
      showStatus: {
        type: Boolean,
        default: true,
      },
    },
    data: () => ({
      resendingInvitation: false,
      cancelingInvitation: false,
      researcher: null,
      showAll: false,
    }),
    methods: {
      ...mapActions({
        resendInvitationNotification: 'protocols/resendInvitationNotification',
        reinviteResearcher: 'protocols/reinviteResearcher',
        removeResearcher: 'protocols/removeResearcher',
        resendExternalInvitationNotification: 'protocols/resendExternalInvitationNotification',
        reinviteExternalResearcher: 'protocols/reinviteExternalResearcher',
        removeExternalResearcher: 'protocols/removeExternalResearcher',
      }),
      cancelInvitation (researcher) {
        this.researcher = researcher
        
        $('#delete-external-researcher-modal').modal('show')
      },
      async deleteResearcher () {
        this.cancelingInvitation = true
        
        try {
          const response = this.researcher.invited_by_email
            ? await this.removeExternalResearcher({
                protocol: this.researcher.protocol_id,
                invitation: this.researcher.id,
              })
            : await this.removeResearcher({
                protocol: this.researcher.pivot.protocol_id,
                researcher: this.researcher.id,
              })
          
          if (response.error) {
            AlertManager.error(response.error)
          } else {
            AlertManager.success(response.message)
          }
        } catch (e) {
          AlertManager.error(e)
          console.error(e)
        }
        
        this.cancelingInvitation = false
        this.researcher          = null
        
        $('#delete-external-researcher-modal').modal('hide')
      },
      async resendInvitation (researcher) {
        this.resendingInvitation = true
        
        const response = researcher.invited_by_email
          ? await this.resendExternalInvitationNotification({
              invitation: researcher.id,
              protocol: researcher.protocol_id,
            })
          : await this.resendInvitationNotification({
              invitation: researcher.pivot.id,
              protocol: researcher.pivot.protocol_id,
            })
        
        const {
                status,
                error,
                message,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        AlertManager.success(message)
        
        this.resendingInvitation = false
      },
      async inviteAgain (researcher) {
        this.resendingInvitation = true

        const response = researcher.invited_by_email
          ? await this.reinviteExternalResearcher({
              invitation: researcher.id,
              protocol: researcher.protocol_id,
            })
          : await this.reinviteResearcher({
              invitation: researcher.pivot.id,
              protocol: researcher.pivot.protocol_id,
            })
        
        const {
                status,
                error,
                message,
              } = response
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        AlertManager.success(message)
        
        this.resendingInvitation = false
      },
      getStatusClasses (researcher) {
        if (researcher.invited_by_email) {
          return {
            'badge-success': researcher.is_accepted,
            'badge-danger': researcher.is_accepted === false,
            'badge-warning': researcher.is_accepted === null
          }
        }

        return {
          'badge-success': researcher.status.key === 'aceptado',
          'badge-warning': researcher.status.key === 'enviado',
          'badge-danger': researcher.status.key === 'rechazado',
          'badge-dark': researcher.status.key === 'cancelado' || researcher.status.key === 'ignorado',
        }
      },
      getStatusTitle (researcher) {
        if (researcher.invited_by_email) {
          switch(researcher.is_accepted) {
            case true:
              return 'Petición aceptada por el coinvestigador.'
            case false:
              return 'Petición rechazada por el coinvestigador.'
            case null:
              return 'Petición enviada al coinvestigador.'
          }
          console.log('exit switch')
        }

        return researcher.status.title
      },
      canResendInvitation (researcher) {
        if (researcher.invited_by_email) {
          return  researcher.is_accepted !== null || this.resendingInvitation
        }

        return researcher.status.key !== 'enviado' || this.resendingInvitation
      },
      canInviteAgain (researcher) {
        if (researcher.invited_by_email) {
          return researcher.is_accepted === false || this.resendingInvitation
        }

        return researcher.status.key === 'rechazado' || this.resendingInvitation
      },
      canCancelInvitation (researcher) {
        if (researcher.invited_by_email) {
          return researcher.is_accepted !== null || this.cancelingInvitation
        }

        return researcher.status.key !== 'enviado' || this.cancelingInvitation
      },
    },
    computed: {
      ...mapGetters({
        readonly: 'protocols/readonly',
      }),
      
      extraSmall () {
        return this.$mq === 'xs'
      },
      small () {
        return this.$mq === 'sm'
      },
    },
  }
</script>
